<template>
  <div>
    <b-card no-body class="mt-4" header="Beratungen" bg-variant="light">
      <b-form-row class="my-1 ml-1">
        <!-- SearchField -->
        <b-col md="4" lg="4" class="my-2">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input
                v-model="searchInput"
                type="search"
                id="searchInput"
                placeholder="Beratung suchen"
              ></b-form-input>
              <b-input-group-append is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!-- SelectField -->
        <b-col md="3" lg="3" class="my-2">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-select v-model="selectInput" :options="monthPicker">
                <template v-slot:first>
                  <b-form-select-option :value="''"
                    >-- Alle Beratungen --</b-form-select-option
                  >
                </template>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-form-row>

      <!-- Table -->
      <b-table
        class="pr-0"
        striped
        borderless
        :items="clientList"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        @filtered="onFiltered"
        head-variant="light"
        sort-icon-left
      >
        <template v-slot:cell(clientName)="{ item }">
          <b-link @click="setClient(item.id)">{{ item.clientName }}</b-link>
        </template>
        <template v-slot:cell(delete)="{ item }">
          <span
            class="odil-icon-herunterladen btn"
            alt="delete"
            data-placement="top"
            title="Löschen"
            @click="deleteModal(item.id, item.clientName)"
            ><b-icon icon="trash" variant="danger"
          /></span>
        </template>
      </b-table>
      <b-pagination
        v-if="totalRows > 10"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        class=""
      ></b-pagination>
    </b-card>

    <div class="my-3">
      <button
        type="button"
        class="btn btn-primary"
        v-b-modal.saveModal
        @click="resetClient()"
      >
        Neue Beratung anlegen
      </button>
    </div>
    <ModalSave />
    <ModalDelete />
  </div>
</template>

<script>
import ModalSave from "@/components/ModalSave.vue";
import ModalDelete from "@/components/ModalDelete.vue";
export default {
  name: "Home",
  components: {
    ModalSave,
    ModalDelete
  },
  data: () => ({
    totalRows: 1,
    currentPage: 1,
    perPage: 10,
    filter: "",
    filterOn: ["clientName", "createdOnString", "creatorName"],
    selectInput: "",
    searchInput: "",
    table: new Object(),
    tableCounter: 0,
    tableSubcounter: 0,
    fields: [
      {
        key: "clientName",
        isActive: true,
        label: "Firmenname",
        sortable: true
      },
      {
        key: "createdOnString",
        isActive: true,
        label: "Erstellt am",
        sortable: true
      },
      {
        key: "creatorName",
        isActive: true,
        label: "Erstellt von",
        sortable: false
      },
      {
        key: "delete",
        label: "Löschen",
        isActive: true,
        sortable: false
      }
    ]
  }),
  mounted() {
    // if there is a givebn query param when mounted then call setIbaLinkClient
    if (this.$route.query.id) {
      this.$store.dispatch("setIbaLinkClient", this.$route.query.id);
    }
    // Set the initial number of items
    this.totalRows = this.clientList.length;
  },
  computed: {
    clientList() {
      return this.$store.state.allClientData;
    },
    monthPicker() {
      return this.$store.getters["monthPicker"];
    }
  },

  watch: {
    searchInput: function(val) {
      this.filter = val;
      if (val == "" || val == null) {
        this.filterOn = ["createdOnString"];
      } else {
        this.filterOn = ["clientName", "createdOnString", "creatorName"];
      }
    },
    selectInput: function(val) {
      this.searchInput = "";
      this.filterOn = ["createdOnString"];
      this.filter = val;
    },
    clientList: function() {
      // Set the initial number of items
      if (this.filter != "" || this.filter != null) {
        this.totalRows = this.clientList.length;
      }
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Für den Fall das in der zwischenzeit neu Clients hinzugef+gt wurden
      this.totalRows = this.clientList.length;
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    setClient(clientID) {
      this.$store.commit("setClient", clientID);
      this.$router.push("Kostentraegerstammdaten");
    },
    resetClient() {
      this.$store.commit("resetClient");
    },
    deleteModal(clientID, clientName) {
      this.$store.commit("setClient", clientID);
      this.$store.commit("setClientName", clientName);
      this.$bvModal.show("delete");
    }
  }
};
</script>
